module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-gta_jf.png?v=b9082266";